import React from 'react';
// eslint-disable-next-line import/no-named-as-default -- posthog-js re-exports its own default as a named `posthog` too
import posthog from 'posthog-js';
import { useDispatch } from 'react-redux';
import {
  DeprecatedModal,
  ModalCancelButton,
  ModalConfirmationButton,
  ModalText,
  ModalTitle,
} from '../../common/DeprecatedModal';
import { correctEnvelope } from '../../store/envelopeManagement/actions';

interface IProps {
  envelopeId: string;
  close: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const CorrectModal = (props: IProps) => {
  const dispatch = useDispatch();
  const { envelopeId, close } = props;

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const onClickCorrect = () => {
    posthog.capture('envelope_corrected');
    dispatch(correctEnvelope(envelopeId));
    close();
  };

  const title = <ModalTitle>Are you sure?</ModalTitle>;
  const content = (
    <ModalText>
      Correcting an envelope will require signed recipients to start over and sign again. While you are correcting,
      recipients will not be able to access this envelope.
    </ModalText>
  );
  const actionButtons = (
    <>
      <ModalCancelButton onClick={close} aria-label="cancel correct envelope">
        Cancel
      </ModalCancelButton>
      <ModalConfirmationButton onClick={onClickCorrect} aria-label="confirm correct envelope">
        Correct Envelope
      </ModalConfirmationButton>
    </>
  );
  return <DeprecatedModal toggleModal={close} title={title} content={content} actionButtons={actionButtons} />;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default CorrectModal;
